import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

interface LaunchDeerAppParams {
  operationType: string;
  sendEmail?: boolean;
}

export const launchDeerAppAPI = ({ operationType, sendEmail }: LaunchDeerAppParams) => {
  const url = endpoints.admin.launchDeer;

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      operationType,
      sendEmail,
    },
  });
};
